import React from 'react';

import { TFunction } from '@lyearn/i18n';
import { CheckMarkFillLegacy, FileError, FileSheet } from '@lyearn/icons';
import { LinkButton } from '@lyearn/ui';
import { JobEntityStatusEnum } from '@/types/schema';

import { ConfigType } from './types';

const IN_PROCESS_CONFIG: Omit<ConfigType, 'progress'> = {
  Icon: <FileSheet />,
  descriptionKey: 'Common:BulkImport.Processing',
};

export const importItemConfig = (
  t: TFunction,
  onDownloadReport: () => void,
  onCancel: () => void,
): Record<JobEntityStatusEnum, ConfigType> => ({
  [JobEntityStatusEnum.NotStarted]: {
    ...IN_PROCESS_CONFIG,
    progress: 0,
    rightNode: (
      <LinkButton className="py-2 px-4" color={'internal'} onClick={onCancel}>
        {t('Common:Actions.Cancel')}
      </LinkButton>
    ),
  },
  [JobEntityStatusEnum.Waiting]: {
    ...IN_PROCESS_CONFIG,
    progress: 0,
    rightNode: (
      <LinkButton className="py-2 px-4" color={'internal'} onClick={onCancel}>
        {t('Common:Actions.Cancel')}
      </LinkButton>
    ),
  },
  [JobEntityStatusEnum.Parsing]: {
    ...IN_PROCESS_CONFIG,
    progress: 33.33,
    rightNode: (
      <LinkButton className="py-2 px-4" color={'internal'} onClick={onCancel}>
        {t('Common:Actions.Cancel')}
      </LinkButton>
    ),
  },
  [JobEntityStatusEnum.Validating]: {
    ...IN_PROCESS_CONFIG,
    progress: 33.33,
    rightNode: (
      <LinkButton className="py-2 px-4" color={'internal'} onClick={onCancel}>
        {t('Common:Actions.Cancel')}
      </LinkButton>
    ),
  },
  [JobEntityStatusEnum.InProcess]: { ...IN_PROCESS_CONFIG, progress: 66.66 },
  [JobEntityStatusEnum.Completed]: {
    Icon: <FileSheet />,
    descriptionKey: 'Common:BulkImport.ImportCompleteDescription',
    progress: 100,
    rightNode: <CheckMarkFillLegacy className="h-28 w-28" fillColorToken="icon-success" />,
  },
  [JobEntityStatusEnum.Cancelled]: {
    Icon: <FileSheet className="grayscale" />,
    descriptionKey: 'Common:BulkImport.Canceled',
    progress: 0,
  },
  [JobEntityStatusEnum.Failed]: {
    Icon: <FileError />,
    descriptionKey: 'Common:BulkImport.ImportFailed',
    progress: 0,
    rightNode: (
      <LinkButton className="py-2 px-4" color={'internal'} onClick={onDownloadReport}>
        {t('Common:BulkImport.DownloadReport')}
      </LinkButton>
    ),
  },
});
